// Données des villes pour pages SEO locales — non listées dans la navigation,
// indexées par Google uniquement (sitemap dynamique).
// Distance = depuis Lille (base d'intervention principale).

export const CITIES = [
  {
    slug: "lille",
    name: "Lille",
    cp: "59000",
    dept: "Nord",
    distance_km: 0,
    drive_min: 0,
    population: "234 000 habitants",
    intro:
      "Lille, capitale des Hauts-de-France, accueille chaque année de nombreux mariages — du Vieux-Lille élégant aux salles modernes d'Euralille. Nous accompagnons régulièrement des mariages à Lille et dans la métropole lilloise.",
    venues: [
      { name: "Hôtel Hermitage Gantois", desc: "Établissement 5★ rue de Paris, connu pour ses réceptions et mariages haut de gamme." },
      { name: "Couvent des Minimes (Alliance)", desc: "Cloître historique du Vieux-Lille, cadre patrimonial recherché pour cérémonies et soirées." },
      { name: "Hospice Comtesse", desc: "Musée et lieu d'exception au cœur du Vieux-Lille." },
      { name: "Le Tripostal", desc: "Lieu industriel reconverti, connu pour ses événements de grande capacité." },
    ],
    keywords: "DJ mariage Lille, DJ Lille, animation mariage Lille, DJ Vieux-Lille, DJ Hermitage Gantois",
    testimonial: "",
    neighbors: ["tourcoing", "roubaix", "armentieres"],
  },
  {
    slug: "tourcoing",
    name: "Tourcoing",
    cp: "59200",
    dept: "Nord",
    distance_km: 15,
    drive_min: 25,
    population: "98 000 habitants",
    intro:
      "Tourcoing, ville dynamique au nord de la métropole lilloise, allie patrimoine industriel et lieux de réception contemporains. Frontière belge à cinq minutes.",
    venues: [
      { name: "Château du Vert-Bois (Bondues)", desc: "Domaine arboré situé à Bondues, aux portes de Tourcoing, connu pour accueillir cérémonies et soirées privées." },
      { name: "Salle Léo Lagrange", desc: "Salle municipale utilisée pour des mariages familiaux." },
      { name: "Park Hôtel Tourcoing", desc: "Hôtel de centre-ville proposant des espaces privatisables." },
    ],
    keywords: "DJ mariage Tourcoing, DJ Tourcoing, animation mariage Tourcoing, DJ Château du Vert-Bois Bondues",
    testimonial: "",
    neighbors: ["lille", "roubaix", "armentieres"],
  },
  {
    slug: "roubaix",
    name: "Roubaix",
    cp: "59100",
    dept: "Nord",
    distance_km: 13,
    drive_min: 22,
    population: "97 000 habitants",
    intro:
      "Roubaix, ville textile historique en pleine renaissance culturelle, propose des lieux de réception originaux — musées reconvertis, hippodrome, salles patrimoniales.",
    venues: [
      { name: "Hippodrome du Croisé-Laroche (Marcq-en-Barœul)", desc: "Site hippique situé à Marcq-en-Barœul, aux portes de Roubaix, connu pour accueillir de grands événements et réceptions privées." },
      { name: "Salle Watremez", desc: "Salle des fêtes historique de la ville." },
      { name: "La Cohue (Lille/Roubaix)", desc: "Loft industriel reconverti pour événements privés." },
    ],
    keywords: "DJ mariage Roubaix, DJ Roubaix, animation mariage Roubaix, DJ Hippodrome Croisé-Laroche Marcq-en-Barœul",
    testimonial: "",
    neighbors: ["lille", "tourcoing", "armentieres"],
  },
  {
    slug: "armentieres",
    name: "Armentières",
    cp: "59280",
    dept: "Nord",
    distance_km: 18,
    drive_min: 25,
    population: "26 000 habitants",
    intro:
      "Armentières, à la frontière belge, est un terroir riche pour les mariages champêtres — fermes rénovées, châteaux et salles communales bien équipées.",
    venues: [
      { name: "Salle des Fêtes d'Armentières", desc: "Salle municipale du cœur de ville pour réceptions familiales." },
      { name: "Château Lestienne (Erquinghem-Lys)", desc: "Cadre champêtre à quelques minutes d'Armentières." },
      { name: "Ferme d'Hellebrouck", desc: "Lieu rural utilisé pour cérémonies laïques et soirées." },
    ],
    keywords: "DJ mariage Armentières, DJ Armentières, animation mariage Armentières, DJ Château Lestienne",
    testimonial: "",
    neighbors: ["tourcoing", "lille", "roubaix"],
  },
  {
    slug: "dunkerque",
    name: "Dunkerque",
    cp: "59140",
    dept: "Nord",
    distance_km: 80,
    drive_min: 60,
    population: "87 000 habitants",
    intro:
      "Dunkerque, plus grand port de pêche français et ville carnavalesque, demande des DJ capables de gérer des soirées énergiques jusqu'au petit matin.",
    venues: [
      { name: "Kursaal de Dunkerque", desc: "Centre de congrès en bord de mer, connu pour les grandes réceptions." },
      { name: "Studio 43", desc: "Lieu polyvalent pour réceptions modernes." },
      { name: "Hôtel Borel", desc: "Hôtel-restaurant proposant des espaces pour mariages intimistes." },
    ],
    keywords: "DJ mariage Dunkerque, DJ Dunkerque, animation mariage Dunkerque, DJ littoral Nord",
    testimonial: "",
    neighbors: ["lille", "bethune"],
  },
  {
    slug: "lens",
    name: "Lens",
    cp: "62300",
    dept: "Pas-de-Calais",
    distance_km: 40,
    drive_min: 40,
    population: "31 000 habitants",
    intro:
      "Lens, ville minière reconvertie autour du Louvre-Lens, allie histoire industrielle et événementiel contemporain, avec un public réputé chaleureux.",
    venues: [
      { name: "Salon Bollaert-Delelis", desc: "Salles VIP du stade Bollaert, connues pour leurs réceptions avec vue sur la pelouse." },
      { name: "Château de Beaurepaire (Hersin)", desc: "Château du 18ᵉ à quelques minutes de Lens." },
      { name: "Salle Jean-Nohain", desc: "Salle municipale utilisée pour mariages familiaux." },
    ],
    keywords: "DJ mariage Lens, DJ Lens, animation mariage Lens, DJ Bollaert, DJ Pas-de-Calais",
    testimonial: "",
    neighbors: ["bethune", "arras"],
  },
  {
    slug: "arras",
    name: "Arras",
    cp: "62000",
    dept: "Pas-de-Calais",
    distance_km: 60,
    drive_min: 50,
    population: "41 000 habitants",
    intro:
      "Arras, ville d'art et d'histoire avec ses Grand-Places flamandes emblématiques et son beffroi inscrit au patrimoine mondial de l'UNESCO (ensemble « Beffrois de Belgique et de France »), propose des lieux de réception prestigieux — hôtels patrimoniaux et citadelle Vauban (également inscrite UNESCO).",
    venues: [
      { name: "L'Hôtel de l'Univers", desc: "Hôtel particulier du 18ᵉ au cœur d'Arras, cadre élégant pour réceptions." },
      { name: "Citadelle d'Arras", desc: "Site Vauban unique pour événements d'exception." },
      { name: "Hôtel Mercure Atria", desc: "Hôtel du centre-ville proposant des espaces modernes de réception." },
    ],
    keywords: "DJ mariage Arras, DJ Arras, animation mariage Arras, DJ Citadelle Arras, DJ Pas-de-Calais",
    testimonial: "",
    neighbors: ["lens", "cambrai", "bethune"],
  },
  {
    slug: "valenciennes",
    name: "Valenciennes",
    cp: "59300",
    dept: "Nord",
    distance_km: 50,
    drive_min: 45,
    population: "44 000 habitants",
    intro:
      "Valenciennes, surnommée \"l'Athènes du Nord\", concentre des lieux raffinés pour mariages : châteaux classés, théâtres, hôtels haut de gamme.",
    venues: [
      { name: "Le Royal Hainaut Spa & Resort", desc: "Hôtel 5★ avec spa, connu pour ses réceptions prestige." },
      { name: "Château de Vicq", desc: "Domaine du 18ᵉ apprécié pour les mariages champêtres-chic." },
      { name: "Théâtre des Forges (Anzin)", desc: "Ancien site industriel reconverti pour événements de grande capacité." },
    ],
    keywords: "DJ mariage Valenciennes, DJ Valenciennes, animation mariage Valenciennes, DJ Royal Hainaut",
    testimonial: "",
    neighbors: ["cambrai", "lille"],
  },
  {
    slug: "cambrai",
    name: "Cambrai",
    cp: "59400",
    dept: "Nord",
    distance_km: 75,
    drive_min: 55,
    population: "32 000 habitants",
    intro:
      "Cambrai, ville d'histoire avec son patrimoine épiscopal et ses traditions culinaires, propose des cadres patrimoniaux pour mariages élégants.",
    venues: [
      { name: "Château de la Motte Fénelon", desc: "Château 4★ à quelques minutes du centre, connu pour ses mariages haut de gamme." },
      { name: "Hôtel Beatus", desc: "Hôtel de charme avec espaces de réception privatisables." },
      { name: "Salle Le Familia", desc: "Salle communale utilisée pour mariages familiaux." },
    ],
    keywords: "DJ mariage Cambrai, DJ Cambrai, animation mariage Cambrai, DJ Château de la Motte Fénelon",
    testimonial: "",
    neighbors: ["valenciennes", "arras"],
  },
  {
    slug: "bethune",
    name: "Béthune",
    cp: "62400",
    dept: "Pas-de-Calais",
    distance_km: 50,
    drive_min: 45,
    population: "25 000 habitants",
    intro:
      "Béthune et son bassin minier (Bruay-La-Buissière, Auchel, Lillers) accueillent de nombreuses fêtes familiales — salles polyvalentes et fermes auberges.",
    venues: [
      { name: "Salle Olof Palme", desc: "Salle des fêtes municipale utilisée pour réceptions familiales." },
      { name: "Domaine de Belmont (Bruay)", desc: "Cadre verdoyant apprécié pour les mariages champêtres." },
      { name: "Salle Mendès France", desc: "Salle de la ville utilisée pour réceptions familiales." },
    ],
    keywords: "DJ mariage Béthune, DJ Béthune, animation mariage Béthune, DJ Pas-de-Calais bassin minier",
    testimonial: "",
    neighbors: ["lens", "arras"],
  },
  // ===== Pages dj-mariage uniquement (mariage_only) — contenu éditorial dédié =====
  {
    slug: "bousbecque",
    name: "Bousbecque",
    cp: "59166",
    dept: "Nord",
    mariage_only: true,
    seo_title: "DJ mariage Bousbecque (59166) — animation locale My Animation",
    seo_description: "My Animation est basé à Bousbecque. DJ mariage, photobooth, sonorisation et éclairage pour vos événements à Bousbecque, Halluin, Comines, Linselles et Wervicq. Devis sous 24 h.",
    h1: "DJ mariage à Bousbecque · votre animateur local",
    intro_title: "Depuis Bousbecque : votre DJ mariage de proximité",
    intro_sub: "Base technique de My Animation",
    intro:
      "Bousbecque est le point d'ancrage de My Animation. Située à la frontière franco-belge, entre la Lys et la métropole lilloise, cette commune de la vallée de la Lys concentre un patrimoine agricole, des bords de Lys propices aux cérémonies en extérieur et de nombreux lieux de réception à moins de 15 minutes — qu'il s'agisse de salles communales, de domaines ruraux ou de châteaux de la métropole proche. Parce que nous habitons et travaillons depuis Bousbecque, nos trajets techniques sont courts, notre matériel est pré-positionné et nous connaissons personnellement la plupart des lieux de la vallée.",
    venues: [
      { name: "Salle des Jonquilles", desc: "Bousbecque centre — salle municipale utilisée pour concerts et événements communaux." },
      { name: "MisilyaEvents", desc: "196 rue de la Lys, Bousbecque — espace privé de réception." },
      { name: "Château du Vert-Bois (Bondues)", desc: "À une dizaine de kilomètres — domaine arboré de 50 ha (Fondation Prouvost)." },
      { name: "Château d'Hem (Hem)", desc: "À une quinzaine de kilomètres — 4 salles de réception modulaires." },
    ],
    venues_note: "Information indicative pour vous aider à visualiser les options locales : nous ne garantissons aucune disponibilité ni partenariat exclusif avec ces lieux.",
    communes: ["Halluin", "Comines", "Wervicq-Sud", "Linselles", "Roncq", "Neuville-en-Ferrain", "Bondues", "Mouvaux", "Mouscron (BE)", "Wervik (BE)"],
    faq: [
      { q: "Vous intervenez vraiment à Bousbecque, ou uniquement « sur demande » ?", a: "Notre base technique est à Bousbecque. Nous intervenons donc à domicile sans supplément de déplacement sur toute la commune, ainsi qu'à Halluin, Comines, Linselles, Wervicq-Sud et Roncq. Pour les lieux au-delà de 20 km, un forfait transport est précisé sur le devis." },
      { q: "Y a-t-il des contraintes sonores particulières à Bousbecque et dans la vallée de la Lys ?", a: "Les salles communales de la vallée de la Lys appliquent souvent une limite horaire (fin de musique autour de 1 h-2 h selon arrêté). Nos sonorisations sont équipées de limiteurs de niveau et nous nous adaptons systématiquement au règlement intérieur de votre lieu, qu'il soit municipal ou privé." },
      { q: "Possible d'organiser une cérémonie laïque extérieure près de la Lys ?", a: "Oui, nos packs sonorisation portable + micros HF sont prévus pour les cérémonies extérieures. Les bords de Lys offrent plusieurs écrins possibles ; nous préparons un plan de secours couvert en cas d'intempéries." },
    ],
    area_served: ["Bousbecque", "Halluin", "Comines", "Linselles", "Wervicq-Sud"],
    keywords: "DJ mariage Bousbecque, DJ Bousbecque, DJ vallée de la Lys, DJ mariage Halluin, DJ mariage Comines",
    testimonial: "",
    neighbors: ["lille", "tourcoing", "roubaix"],
  },
  {
    slug: "hem",
    name: "Hem",
    cp: "59510",
    dept: "Nord",
    mariage_only: true,
    seo_title: "DJ mariage Hem (59510) — animation Château d'Hem & salles locales",
    seo_description: "My Animation sonorise vos mariages à Hem, Roubaix, Croix et Villeneuve-d'Ascq. Expérience des réceptions au Château d'Hem et au Centre Le Comte. Devis sous 24 h.",
    h1: "DJ mariage à Hem · animation professionnelle locale",
    intro_title: "Hem, l'écrin vert de la métropole lilloise",
    intro_sub: "25 à 30 min depuis Bousbecque",
    intro:
      "Hem s'inscrit comme une des communes les plus demandées de l'est lillois pour les réceptions de mariage, grâce à son patrimoine arboré et à ses domaines privatisables. Entre le Domaine du Château d'Hem — avec ses quatre salles indépendantes au sein d'un parc de quatre hectares — et le Centre Le Comte en bordure du centre équestre, la ville propose aux mariés de la métropole des cadres parfois ruraux, parfois plus modernes. Depuis notre base à Bousbecque, nous rejoignons Hem en 25 à 30 minutes, et nous connaissons les contraintes acoustiques et techniques spécifiques de ces lieux (sols en gravier, salles mitoyennes, règlement intérieur, couverture Wi-Fi faible dans certaines parties du parc).",
    venues: [
      { name: "Domaine du Château d'Hem", desc: "61 avenue Henri Delecroix, Hem — 4 salles de 35 à 120 personnes, jusqu'à 350 au total." },
      { name: "O'Green du Château d'Hem", desc: "61 avenue Henri Delecroix, Hem — de 10 à 200 personnes, restaurant et animations." },
      { name: "Centre Le Comte", desc: "Rue de Croix, Hem — 3 espaces modulables, jusqu'à 200 personnes." },
      { name: "Auberge du Tilleul", desc: "Hem — de 20 à 160 invités, service traiteur." },
    ],
    communes: ["Roubaix", "Croix", "Lys-lez-Lannoy", "Forest-sur-Marque", "Villeneuve-d'Ascq", "Lannoy", "Toufflers"],
    faq: [
      { q: "Vous avez déjà sonorisé des mariages au Château d'Hem ?", a: "Oui, nous intervenons régulièrement sur le domaine. Les quatre salles (Tilleul, Cerisier, Érable, Peuplier) ont chacune des contraintes acoustiques différentes — notamment la gestion du son entre salles mitoyennes quand plusieurs réceptions ont lieu le même soir. Nous adaptons systématiquement nos niveaux et la direction des enceintes." },
      { q: "Quelle logistique pour une cérémonie extérieure dans le parc ?", a: "Nous apportons un pack sonorisation portable autonome (batterie) avec deux micros HF pour l'officiant et les lecteurs. Prévoir une sonorisation séparée dans la salle de dîner — nous proposons cette double installation en forfait sur-mesure." },
      { q: "Le Centre Le Comte est en zone équestre, est-ce un souci pour le son ?", a: "Pas spécifiquement. Le site est libre de traiteur et autorise les prestataires extérieurs. Les trois espaces (domaine principal, Espace Champêtre, Salle Cosy) sont indépendants et bien insonorisés les uns des autres." },
    ],
    area_served: ["Hem", "Roubaix", "Croix", "Lys-lez-Lannoy", "Villeneuve-d'Ascq"],
    keywords: "DJ mariage Hem, DJ Château d'Hem, DJ Centre Le Comte, DJ mariage Croix, DJ mariage Roubaix",
    testimonial: "",
    neighbors: ["roubaix", "tourcoing", "lille"],
  },
  {
    slug: "dainville",
    name: "Dainville",
    cp: "62000",
    dept: "Pas-de-Calais",
    mariage_only: true,
    seo_title: "DJ mariage Dainville (62000) — animation secteur Arras ouest",
    seo_description: "My Animation anime vos mariages à Dainville et dans tout le grand Arras : L'Hermitage de Fampoux, Elegance Events, Manoir de Camblain. Devis sous 24 h.",
    h1: "DJ mariage à Dainville · animation secteur Arras ouest",
    intro_title: "Dainville, aux portes ouest d'Arras",
    intro_sub: "Secteur grand Arras",
    intro:
      "Dainville est un faubourg résidentiel immédiatement contigu à Arras (ouest), traversé par la Scarpe. La commune elle-même ne compte pas de grands domaines de réception, mais elle bénéficie de tout l'écosystème arrageois : citadelle Vauban (UNESCO), hôtels patrimoniaux du centre historique, et plusieurs domaines à moins de 15 minutes vers Fampoux, Saint-Laurent-Blangy ou Camblain-l'Abbé. Depuis Bousbecque, l'intervention à Dainville représente environ 1 h 10 d'autoroute : nous ajustons toujours la logistique (horaire d'arrivée, repas prestataires, retour) pour ne jamais rogner sur le temps d'installation.",
    venues_title: "Lieux de réception dans le grand Arras",
    venues: [
      { name: "L'Hermitage de Fampoux", desc: "2 rue des Étangs, 62118 Fampoux — à 15 min à l'est d'Arras." },
      { name: "Elegance Events", desc: "Saint-Laurent-Blangy — contigu à Arras est." },
      { name: "Manoir de Camblain", desc: "207 rue d'Arras, 62690 Camblain-l'Abbé — à 15 min au nord d'Arras." },
      { name: "Mercure Arras Centre Gare", desc: "Arras centre-ville." },
    ],
    venues_note: "Aucun lieu de réception majeur n'est répertorié dans Dainville même : nous vous présentons les lieux du grand Arras, à quelques minutes.",
    communes: ["Arras", "Beaurains", "Achicourt", "Agny", "Wagnonlieu", "Duisans", "Saint-Nicolas-lez-Arras"],
    faq: [
      { q: "Vous êtes basés dans le Nord ; est-ce un frein pour animer à Dainville ?", a: "Non, nous intervenons régulièrement sur le secteur Arras. L'autoroute A1/A26 nous permet d'arriver 2 h avant le vin d'honneur, de monter sereinement le matériel et d'être totalement opérationnels pour l'arrivée des mariés. Un forfait déplacement est précisé sur chaque devis — sans surprise." },
      { q: "Vous connaissez l'Hermitage de Fampoux ou les salles d'Arras ?", a: "Oui, nous avons déjà couvert plusieurs mariages dans le secteur arrageois. Chaque lieu a ses particularités (notamment en matière de courant électrique disponible et de contraintes horaires). Nous demandons toujours la fiche technique du lieu en amont." },
      { q: "Possible d'intégrer la citadelle Vauban d'Arras à notre cérémonie ?", a: "La citadelle d'Arras, également inscrite au patrimoine mondial de l'UNESCO (fortifications de Vauban), accueille certains événements privés mais sous conditions strictes. Pour un mariage avec DJ, les lieux de réception des alentours sont plus adaptés — mais nous pouvons tout à fait prévoir une sonorisation portable pour une cérémonie laïque extérieure si le lieu l'autorise." },
    ],
    area_served: ["Dainville", "Arras", "Beaurains", "Achicourt", "Agny"],
    keywords: "DJ mariage Dainville, DJ mariage Arras, DJ Hermitage de Fampoux, DJ Manoir de Camblain, DJ Pas-de-Calais",
    testimonial: "",
    neighbors: ["arras", "lens", "bethune"],
  },
];

export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
export const SERVICE_CITIES = CITIES.filter((c) => !c.mariage_only);
